import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useUserApprovalMutation = () => {
  return useMutation({
    mutationFn: api.user.approvalUser,
  });
};

export default useUserApprovalMutation;
